import { render } from "./VisitorReasonForVisitColumn.vue?vue&type=template&id=4ddaea30"
import script from "./VisitorReasonForVisitColumn.vue?vue&type=script&lang=js"
export * from "./VisitorReasonForVisitColumn.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__